import React from 'react';
import tw, { styled } from 'twin.macro';

import { motion } from '@sopranodesign/framer-motion';
import {
  Flex,
  Label,
  useTheme,
  NumberFormatter,
  Heading2,
  Tag,
  Span
} from '@sopranodesign/pulse-components';
import Icon from '@sopranodesign/pulse-icons';

import { useMetric } from '../../../hooks/index';

const Pulse = styled(
  (
    {
      transition = {
        duration: 1,
        repeat: Infinity,
        repeatType: 'loop',
        repeatDelay: 1,
        delay: 0.5
      },
      initial = { opacity: 0 },
      animate = { scale: [1, 2.5], opacity: [0.75, 0] },
      ...props
    }
  ) => <motion.div transition={transition} initial={initial} animate={animate} {...props} />
)`
  ${tw`w-2 h-2 rounded-full`}
  background: ${props => props.theme.primary};
`;

const Dot = styled(motion.div)`
  ${tw`w-2 h-2 absolute rounded-full`}
  background: ${props => props.theme.primary};
`;

const IconContainer = styled.div`
  ${tw`absolute opacity-25`}
  right: 2.5rem;
  bottom: 1rem;
`;

const LiveValueMetric = () => {
  const { metric } = useMetric();
  const { primary } = useTheme();

  return (
    <Flex fat="true" center relative tall pl pr>
      <Flex absolute style={{ right: '0.5rem', top: '0.5rem' }}>
        <Tag>
          <Flex center middle xSpaceSm>
            <Flex relative middle center>
              <Pulse />
              <Dot />
            </Flex>
            <Span>Live</Span>
          </Flex>
        </Tag>
      </Flex>
      <IconContainer>
        <Icon
          data-testid="metric-icon"
          type={metric.data.data.icon}
          colour={primary}
          stroke={primary}
          width="5rem"
          height="5rem"
        />
      </IconContainer>
      <Flex col ml>
        <Heading2 style={{ fontSize: '1.875rem' }}>
          <NumberFormatter>{metric.data.data.value}</NumberFormatter>
        </Heading2>
        <Label mb={false}>{metric.data.label}</Label>
      </Flex>
    </Flex>
  );
};

export default LiveValueMetric;
